import { BottomFixedModal } from "@src/shared/src";

type Props = {
  isTransition?: boolean;
  transitionEndCallback?: () => void;
  touchEventCallback?: () => void;
  isShow: boolean;
  hideModal: () => void;
  title: string;
  children: React.ReactNode;
  style?: any;
  className?:string;
};
export default function HallSearchFixedBottomSheet({
  isTransition = false,
  transitionEndCallback,
  touchEventCallback,
  isShow,
  hideModal,
  title,
  children,
  style,
  className
}: Props) {
  return (
    <BottomFixedModal
      isTransition={isTransition}
      isShow={isShow}
      hideModal={hideModal}
      title={title}
      hasCloseButton={true}
      closeButtonPosition="title"
      modalStyle={{ minHeight: "90vh", maxHeight: "90vh", height: "90vh" ,zIndex:'100010'}} //퀵버튼 보다 위로 Z-index 조정 (퀵버튼:100001)
      contentStyle={style}
      hasInnerScroll={true}
      className={className}
    >
      {children}
    </BottomFixedModal>
  );
}
